import { TrackingStatus } from "@babackapp/tracking-status-registry";

const EXCLUDED_STATUSES = new Set<string>([TrackingStatus.ORDER_NOT_FULFILLED]);

const VALID_TRIGGER_STATUSES = new Set<string>(
  Object.values(TrackingStatus).filter((s) => !EXCLUDED_STATUSES.has(s))
);

/**
 * Type guard to check if a tracking status is valid for use as a trigger.
 * ORDER_NOT_FULFILLED is excluded as it's a custom trigger, not a real tracking status.
 */
export const isValidTrackingStatus = (
  status: unknown,
): status is Exclude<TrackingStatus, "ORDER_NOT_FULFILLED"> => {
  return typeof status === "string" && VALID_TRIGGER_STATUSES.has(status);
};
